/*
 * nadi-a11y.js — every link says where it goes.
 *
 * WHAT WAS WRONG. Audited on the homepage at 1440: 45 visible links with no
 * accessible name at all — no text, no aria-label, no title, no alt on an image
 * inside them. A screen reader announces each one as "link" and nothing else.
 * That is WCAG 2.0 AA 2.4.4 and 4.1.2, which Israeli accessibility regulation
 * adopts through תקן ישראלי 5568, and this store publishes an accessibility
 * statement and runs an accessibility widget — so the gap is not academic.
 *
 * They come from Kalles' own patterns, not from anything written here: the
 * invisible `t4s-full-width-link` that makes a whole card or banner clickable,
 * the header's icon-only links, and the brand logo strip.
 *
 * TWO REMEDIES, AND WHICH ONE APPLIES IS DECIDED BY THE PAGE, NOT BY GUESSWORK.
 *
 * 1. If the same card already holds a NAMED link to the same destination — a
 *    product card has both its title link and an invisible overlay over the
 *    whole tile — the overlay is taken out of the accessibility tree. The
 *    destination is already reachable by name; a second, nameless route to it
 *    is noise. 32 of the 45 are this case.
 *
 * 2. Otherwise the link is given a name taken from WHERE IT ACTUALLY GOES. For
 *    a collection that is its real title, read from #NadiBrands, the block
 *    snippets/nadi-brand-data.liquid already prints on every page for the card
 *    brand line — so the name is the store's own wording, not a guess. For the
 *    header's fixed destinations it is the obvious Hebrew label. Nothing is
 *    invented and no visible text changes.
 *
 * A link with an EMPTY href is a third case and gets the first remedy: it is
 * decoration that happens to be an <a>, and announcing it helps nobody.
 *
 * This runs everywhere, phone included — an unnamed link is unnamed at every
 * width, and it is the mobile visitor using a screen reader who meets the
 * drawer and the cards most.
 */
(function () {
  'use strict';

  /* The store's real collection titles, keyed by handle. Same block the brand
     line reads; see snippets/nadi-brand-data.liquid. */
  var TITLES = (function () {
    var map = {};
    try {
      var el = document.getElementById('NadiBrands');
      if (!el) return map;
      var rows = JSON.parse(el.textContent) || [];
      for (var i = 0; i < rows.length; i++) map[rows[i][1]] = rows[i][0];
    } catch (e) { /* no map: fall back to the handle */ }
    return map;
  })();

  var FIXED = {
    '/search': 'חיפוש',
    '/account': 'החשבון שלי',
    '/cart': 'עגלת הקניות',
    '/': 'לעמוד הבית'
  };

  function named(el) {
    if (!el) return false;
    if ((el.textContent || '').trim()) return true;
    if (el.getAttribute('aria-label') || el.getAttribute('title')) return true;
    var img = el.querySelector('img[alt]');
    if (img && (img.getAttribute('alt') || '').trim()) return true;
    var t = el.querySelector('svg title');
    return !!(t && (t.textContent || '').trim());
  }

  function hide(a) {
    a.setAttribute('aria-hidden', 'true');
    a.setAttribute('tabindex', '-1');
  }

  function nameFromHref(href) {
    if (!href) return '';
    var path = href;
    try { path = new URL(href, location.origin).pathname; } catch (e) { /* relative already */ }
    if (FIXED[path]) return FIXED[path];

    var m = path.match(/\/collections\/([^/?#]+)/);
    if (m) {
      var handle;
      try { handle = decodeURIComponent(m[1]); } catch (e) { handle = m[1]; }
      return TITLES[handle] || handle.replace(/-/g, ' ');
    }
    m = path.match(/\/products\/([^/?#]+)/);
    if (m) {
      var ph;
      try { ph = decodeURIComponent(m[1]); } catch (e) { ph = m[1]; }
      return ph.replace(/-/g, ' ');
    }
    if (/\/search/.test(path)) return 'חיפוש';
    return '';
  }

  function fix() {
    document.querySelectorAll('a').forEach(function (a) {
      if (a.dataset.nadiA11y) return;
      if (named(a)) return;
      if (!a.getClientRects().length) return;      /* not painted: leave it */
      a.dataset.nadiA11y = '1';

      var href = a.getAttribute('href');
      if (!href || href === '#') { hide(a); return; }

      /* Already reachable by name from within the same card? */
      var card = a.closest('.t4s-product, .t4s-slideshow-item, .t4s-banner-item, .t4s-col-item, li');
      if (card) {
        var twin = [].slice.call(card.querySelectorAll('a')).some(function (x) {
          return x !== a && x.getAttribute('href') === href && (x.textContent || '').trim();
        });
        if (twin) { hide(a); return; }
      }

      var label = nameFromHref(href);
      if (!label) { hide(a); return; }
      a.setAttribute('aria-label', label);

      /* An unlabelled image inside a now-named link would be announced twice,
         once as the label and once as the file. Mark it decorative. */
      a.querySelectorAll('img:not([alt])').forEach(function (i) { i.setAttribute('alt', ''); });
    });
  }

  /*
   * CONTROLS, THE HEADING AND MOTION — added 2026-10-23 after an audit against
   * IS 5568. fix() above only looks at links; these are the rest.
   *
   * Controls are named by WHAT THEY ARE, and that has to run before fix(): the
   * mobile menu button is an <a href="/">, so fix() would read its href and
   * announce the menu as "לעמוד הבית". Naming it first makes fix() skip it.
   */
  var CONTROLS = [
    ['.t4s-push-menu-btn', 'תפריט'],
    ['button.is--minus', 'הפחתת כמות'],
    ['button.is--plus', 'הוספת כמות'],
    ['input.t4s-quantity-input', 'כמות'],
    ['input.t4s-newsletter__email', 'כתובת אימייל להרשמה לניוזלטר'],
    ['a.t4s-product__review', 'ביקורות על המוצר'],
    ['a.t4s-minicart-recommendations__item--qv', 'תצוגה מהירה של המוצר'],
    ['input.t4s-mini-search__input', 'חיפוש מוצרים'],
    ['button.t4s-mini-search__submit', 'חיפוש'],
    ['#CartDiscountcode', 'קוד קופון'],
    /* Share icons on the product page. */
    ['a.facebook', 'שיתוף בפייסבוק'],
    ['a.whatsapp', 'שיתוף בוואטסאפ'],
    ['a.email', 'שיתוף במייל']
  ];

  function nameControls() {
    CONTROLS.forEach(function (row) {
      document.querySelectorAll(row[0]).forEach(function (el) {
        if (el.getAttribute('aria-label') || (el.textContent || '').trim()) return;
        el.setAttribute('aria-label', row[1]);
      });
    });

    /* The 1/2/3/4-column switch on collection and search pages. */
    document.querySelectorAll('button[data-col]').forEach(function (b) {
      if (b.getAttribute('aria-label')) return;
      var col = b.getAttribute('data-col');
      b.setAttribute('aria-label',
        col === 'list_t4s' ? 'תצוגת רשימה' : col === '1' ? 'תצוגה בעמודה אחת' : 'תצוגה ב-' + col + ' עמודות');
    });
  }

  /*
   * The homepage H1 is the shop name inside .t4s-d-none, i.e. display:none, so
   * a screen reader finds no H1 and starts the page at an H2. Kept out of
   * sight, but moved from "not rendered" to "visually hidden".
   */
  function revealHeading() {
    var h1 = document.querySelector('h1.site-header__logo.t4s-d-none');
    if (!h1) return;
    h1.classList.remove('t4s-d-none');
    /* The shop name is "Nadi supply - נדי ציוד למספרות", so the page was
       announced as starting in English. The heading says the Hebrew half. */
    h1.textContent = 'נדי ציוד למספרות';
    h1.style.cssText = 'position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
  }

  /*
   * WCAG 2.2.2: anything that moves on its own for more than five seconds needs
   * a way to stop it. Kalles' carousels auto-advance every 1.5–3.5s with no
   * pause control, and "pause on hover" does not exist on a phone. Instead of
   * adding a pause button to every carousel, auto-advance is switched off:
   * every slider still swipes and still has its dots and arrows.
   * Flickityt4s.data() returns the instance once Kalles has built it, which can
   * be after this script runs, so this is retried from the observer below.
   */
  function stillSliders() {
    if (!window.Flickityt4s || !window.Flickityt4s.data) return;
    document.querySelectorAll('[data-flickityt4s-js]').forEach(function (el) {
      if (el.dataset.nadiStill) return;
      var f = window.Flickityt4s.data(el);
      if (!f) return;
      el.dataset.nadiStill = '1';
      if (!f.options.autoPlay) return;
      f.options.autoPlay = false;
      if (f.stopPlayer) f.stopPlayer();
      /* Stopped mid-transition, a slider rests between two cells — the
         announcement bar showed half of each message. Snap to the first. */
      if (f.select) f.select(0, false, true);
    });
  }

  function run() {
    nameControls();
    revealHeading();
    fix();
    stillSliders();
  }

  run();

  /* Cards, slides and the brand strip all arrive or re-render late on this
     theme. Same answer the cart bar and the brand line reached. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  /* Sliders built after the last DOM change would be missed by the observer. */
  window.addEventListener('load', function () { setTimeout(stillSliders, 500); });
})();
